import { connect } from "react-redux";
import MessageFooter from "./MessageFooter";

const mapState = ({ chats,users }) => ({
  messagingUser: chats.messagingUser,
  myData: users.myData,
});
export default connect(mapState)(MessageFooter);
